import { reduxKey } from './constants';
export function getUnreadChatsCount(state) {
    if (!state[reduxKey]) {
        return 0;
    }
    return state[reduxKey];
}
